import {
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Row, Col} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$cc(Row, {
        'children': [
            _$cc(Col, {
                'span': '6',
                'order': '4',
                'children': '1 col-6 order-4'
            }),
            _$cc(Col, {
                'span': '6',
                'order': '3',
                'children': '2 col-6 order-3'
            }),
            _$cc(Col, {
                'span': '6',
                'order': '2',
                'children': '3 col-6 order-2'
            }),
            _$cc(Col, {
                'span': '6',
                'order': '1',
                'children': '4 col-6 order-1'
            })
        ]
    });
};